// TODO:This need to be removed as website is not yet ready
export const WEBSITE_ENVIRONMENT_URL_CONFIG = {
  LOCAL_HOST: 'localhost',
  DEV_URL: 'http://web.fireflink.com',
  DEV2_URL: 'https://webtest3.fireflink.com',
  TEST_URL: 'http://webtest.fireflink.com',
  PRE_PROD_URL: 'https://websitepreprod.fireflink.com',
  PRODUCTION1_URL: 'https://webprod.fireflink.com',
  PRODUCTION_URL: 'https://www.fireflink.com',
  ALPHA_URL: 'https://webalpha.fireflink.com',
  BETA_URL: 'http://webbeta.fireflink.com',
  DEV_WEB_SERVICE_URL: 'http://devwswb.fireflink.com',
  PRODUCTION_CONTACTUS_URL: 'https://www.fireflink.com/contactus',
};

export default WEBSITE_ENVIRONMENT_URL_CONFIG;
